import axios from 'axios'
import { Goal, CreateGoalRequest, UpdateGoalRequest } from '../types'

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
})

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

interface GoalsResponse {
  success: boolean
  data: Goal[]
}

interface GoalResponse {
  success: boolean
  data: Goal
}

export const getGoals = async (studentId?: string): Promise<GoalsResponse> => {
  const params = studentId ? { studentId } : {}
  const response = await api.get('/goals', { params })
  return response.data
}

export const getGoalsByStudent = async (
  studentId: string,
): Promise<GoalsResponse> => {
  const response = await api.get('/goals', { params: { studentId } })
  return response.data
}

export const getGoal = async (id: string): Promise<GoalResponse> => {
  const response = await api.get(`/goals/${id}`)
  return response.data
}

export const createGoal = async (
  goalData: CreateGoalRequest,
): Promise<GoalResponse> => {
  const response = await api.post('/goals', goalData)
  return response.data
}

export const updateGoal = async (
  id: string,
  goalData: UpdateGoalRequest,
): Promise<GoalResponse> => {
  const response = await api.put(`/goals/${id}`, goalData)
  return response.data
}

export const deleteGoal = async (id: string): Promise<{ success: boolean }> => {
  const response = await api.delete(`/goals/${id}`)
  return response.data
}

interface BulkImportGoalResponse {
  success: boolean
  message: string
  data: {
    successful: number
    failed: number
    studentsCreated: number
    errors: Array<{
      index: number
      error: string
      goal: any
      type?: string
    }>
  }
}

export const bulkImportGoals = async (
  goals: Array<{
    studentId: string
    firstName: string
    lastName: string
    category: string
    area: string
    description: string
    objectives: string
  }>,
): Promise<BulkImportGoalResponse> => {
  const response = await api.post('/goals/bulk-import', { goals })
  return response.data
}
